<template>
  <!--===========================外呼对练记录Tab===========================-->
  <div>
    <p class="nav isreturn" @click="toSceneList"><span class="el-icon-arrow-left"></span><span>返回</span></p>
  <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
    
    <el-tab-pane label="扮演客服记录" name="actAsKf">

      <div class="content-wrap">
        <!-- <el-form :inline="true">
          <el-form-item label="练习时间">
            <el-date-picker
                    v-model="queryDate"
                    type="daterange"
                    range-separator="~"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" style="width: 260px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item
                  label="最低分数"
                  prop="minScore"
                  :rules="[
            { type: 'number', message: '必须为数字值'}
          ]"
          >
            <el-input type="minScore" v-model.number="searchData.minScore" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
                  label="最高分数"
                  prop="maxScore"
                  :rules="[
            { type: 'number', message: '必须为数字值'}
          ]"
          >
            <el-input type="maxScore" v-model.number="searchData.maxScore" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
            <!-- <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="primary" @click="exportList">导出</el-button>
            <el-button type="primary" @click="gobackScene">返回</el-button>
          </el-form-item>
        </el-form>  -->
        <el-table :data="list" border highlight-current-row style="width: 100%">
          <el-table-column prop="beginTime" label="练习时间" align="center" width="150"></el-table-column>
          <el-table-column prop="courseName" label="课程名称" align="center" show-overflow-tooltip width="280"></el-table-column>
          <el-table-column prop="callType" label="呼叫类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.callType == 'inbund'">内呼</span>
              <span v-if="scope.row.callType == 'outbund'">外呼</span>
            </template>
          </el-table-column>
          <el-table-column label="练习结果" align="center">
            <el-table-column prop="baseScore" label="基本条件" align="center"></el-table-column>
            <el-table-column prop="skillScore" label="服务技巧" align="center"></el-table-column>
            <el-table-column prop="riteScore" label="服务礼仪" align="center"></el-table-column>
            <el-table-column prop="flowScore" label="服务流程" align="center"></el-table-column>
          </el-table-column>
          <el-table-column prop="callInterval" label="时长(秒)" align="center"></el-table-column>
          <el-table-column prop="gradeScore" label="分数" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope='scope'>
              <a class="link-text" :href="'/tjkStudy/train/eachRecordDetail?id='+scope.row.id + '&kf=' + tjkId" target="_blank">查看详情{{searchData.total}}</a>
            </template>
          </el-table-column>
        </el-table>

        <pagination :pages="searchData.pages" :pageNum="searchData.pageNum" @getData="getList"></pagination>
      </div>
    </el-tab-pane>
    <!--===========================扮演客户记录Tab===========================-->
    <el-tab-pane label="扮演客户记录" name="actAsKh">
      <div class="content-wrap">
        <el-form :inline="true">
          <!-- <el-form-item label="扮演时间">
            <el-date-picker
                    v-model="queryDate"
                    type="daterange"
                    range-separator="~"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" style="width: 260px;">
            </el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item> -->
            <!-- <el-button type="primary" @click="getList">查询</el-button> -->
            <!--<el-button type="primary" @click="exportList">导出</el-button>-->
            <!-- <el-button type="primary" @click="gobackScene">返回</el-button>
          </el-form-item> -->
        </el-form>
        <el-table :data="listActKh" border highlight-current-row style="width: 100%">
          <el-table-column prop="beginTime" label="扮演时间" align="center" ></el-table-column>
          <el-table-column prop="courseName" label="课程名称" align="center" show-overflow-tooltip width="280"></el-table-column>
          <el-table-column prop="callType" label="呼叫类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.callType == 'inbund'">内呼</span>
              <span v-if="scope.row.callType == 'outbund'">外呼</span>
            </template>
          </el-table-column>
          <el-table-column prop="teacherName" label="练习对象" align="center"  >
            <template slot-scope="scope">
              {{ scope.row.teacherName }}（{{ scope.row.teacherTjkNumber }}）
            </template>
          </el-table-column>
          <el-table-column prop="videoUrl" label="练习录音" align="center">
            <template slot-scope="scope">
              <audio :src="scope.row.videoUrl" controls="controls"></audio>
            </template>
          </el-table-column>
        </el-table>

        <pagination :pages="searchData.pages" :pageNum="searchData.pageNum" @getData="getList"></pagination>
      </div>

    </el-tab-pane>
  </el-tabs>

</div>

</template>
<script>
    import pagination from '@/components/pagination'
    export default {
        components: { pagination },
        data () {
            return {
                businessMajorId: this.$route.query.businessMajorId, //场景id
                searchData: {
                    pageNum:1,
                    pageSize:10,
                    pages:0,
                    tjkId: null,//receivePhoneIsKf=false
                    trainId: this.$route.query.trainId,
                    kf: this.$route.query.tjkId,//receivePhoneIsKf=true
                    minScore:'',
                    maxScore:'',
                    effectStatus: this.$route.query.effectStatus,
                    callInterVal: this.$route.query.callInterVal,
                    qcEffectStatus: this.$route.query.qcEffectStatus,
                    goodStatus: null,
                    qcStatus: null,
                    callInterval: this.$route.query.callInterVal
                },
                searchDataKh: {
                    pageNum:1,
                    pageSize:10,
                    pages:0,
                    kh: this.$route.query.tjkId,//receivePhoneIsKf=true
                    toTjkId: null,//receivePhoneIsKf=false
                    trainId: this.$route.query.trainId,
                    effectStatus: this.$route.query.effectStatus,
                    callInterVal: this.$route.query.callInterVal,
                    qcEffectStatus: this.$route.query.qcEffectStatus,
                    callInterval: this.$route.query.callInterVal
                },
                queryDate:[this.getCurrentDate().monthStartDate, this.getCurrentDate().monthEndDate],//培训时间
                queryBeginTime:this.$route.query.beginTime,
                queryEndTime:this.$route.query.endTime,
                majorList: [],
                list:null,
                listActKh:null,
                tjkId: this.$route.query.tjkId,
                activeName: 'actAsKf'
            }
        },
        mounted: function () {
         
            this.getList();
        },
        methods: {
          toSceneList(){
             this.$router.back()
          },
            handleClick(tab, event) {
                this.getList();
            },


            updateTjkId(val) {
                this.searchData.tjkId = val.id;
            },
            updateToTjkId(val) {
                this.searchData.toTjkId = val.id;
            },
            //点分页组件的数字/下一页，会回传pageNum过来，平时直接点查新，参数是event对象，所以需要isNAN判断
            getList(pageNum) {
                var param = null;
                if(this.activeName == 'actAsKh'){
                  param = this.searchDataKh;
                }else{
                  param = this.searchData;
                }
                param.trainId = this.searchData.trainId;
                if(pageNum && isNaN(pageNum) == false){
                    param.pageNum = pageNum;
                }
                param.courseId = this.$route.query.courseId;
                var self = this;
                this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryExerciseRecordAll', param).then(response=> {
                    var result = response.data;
                    if(result.success) {
                        self.searchData.pages = result.data.pages;
                        if(self.activeName == 'actAsKh'){
                            self.listActKh = result.data.list;
                        }else{
                            self.list = result.data.list;
                        }
                    }else {
                        this.$alert(result.msg);
                    }
                },response=> {
                    this.$alert("网络繁忙，请稍后重试！");
                })
            },
            exportList() {
                window.open(API_ROOT.college + '/export/excel/exportVoiceEachExerciseRecordAll?' + this.urlEncode(this.searchData));
            },
            gobackScene() {
                this.$router.go(-1);
                // this.$router.push({path: '/train/courseList', query: {id: this.businessMajorId, type: 'SkillUpgrade', show:'no'}});
            }
        }
    }
</script>
<style scoped>
/deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{color: #fff;border-radius: 20px 20px 0 0;margin-top: 10px;margin-left: 10px;
    background-color: #497af2;
}
.isreturn{padding-left: 10px !important;cursor: pointer;background:#f5f6f7;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/record/eachExerciseRecordAll.vue